import $api from '@/shared/services/api'
import Vue from 'vue'

export default class ErpService {
    static async buscaUsuarios() {
        return await $api.get('usuarios');
    }

    static async buscaCep(cep) {
        return await $api.get(`${Vue.prototype.$urlBase}/cidades/busca_cep/${cep}`);
    }

    static async buscaFormaPagamento(dados) {
        return await $api.post(`${Vue.prototype.$urlBase}/formas_pagamentos/buscaFormaPagamento`, dados);
    }

    static async buscaFormasPagamentos(q = '') {
        return await $api.get(`${Vue.prototype.$urlBase}/formas_pagamentos/buscaFormasPagamentos?q=${q}`);
    }

    static async getParcelas(dados) {
        return await $api.post(`${Vue.prototype.$urlBase}/vendas_produtos/gera_parcelas`, dados); //temporário
    }

    static async getCategoriaPadrao(modulo) { //PP, PS OU PV
        return await $api.get(`${Vue.prototype.$urlBase}/categorias_movimentacoes_financeiras/buscaCategoriaPadrao?modulo=${modulo}`)
    } 
}